import $ from 'jquery'
import { Popover } from 'bootstrap'
import { isNonEmptyString, tsInitVueGrid, tsInitVue } from "./js-utils"
import axios from "axios"
import Rails from "@rails/ujs"
import CurricularActivityRegistration from "./vue-components/curricular-activity-registration.vue"
import { Application } from "@/js/lite-js/application";
import { ActivityFormController } from "@/js/controllers/ospe/activity-form-controller";

Application.register('ospe-activity-form', ActivityFormController)

document.addEventListener('DOMContentLoaded', function () {

  const activityFormEl = document.querySelector('.ospe.activities-form')
  if (activityFormEl) {
    const onlineFormsCb = document.querySelector('input[ref="online-application-enabled-cb"]')
    if (onlineFormsCb instanceof HTMLInputElement) {
      const dateInputEls = document.querySelectorAll('div[ref="online-application-dates"] input')
      const datePickerBtnEls = document.querySelectorAll('div[ref="online-application-dates"] .btn-picker')

      const enableOnlineApplicationDates = function (): void {
        const disableDates = !onlineFormsCb.checked
        // for (const inputEl of dateInputEls) {
        for (let i = 0; i < dateInputEls.length; i++) {
          const el = dateInputEls[i]
          if (el instanceof HTMLInputElement) {
            el.disabled = disableDates
          }
        }
        for (let i = 0; i < datePickerBtnEls.length; i++) {
          const el = datePickerBtnEls[i]
          if (el instanceof HTMLButtonElement) {
            el.disabled = disableDates
          }
        }
      }
      onlineFormsCb.addEventListener('change', function () {
        enableOnlineApplicationDates()
      })
      enableOnlineApplicationDates()
    }

    const cfhCb = document.querySelector('input[ref="cfh-enabled-cb"]')
    if (cfhCb instanceof HTMLInputElement) {
      const cfhFields = document.querySelectorAll('div[ref="cfh-dates"] input, div[ref="cfh-dates"] .btn-picker')
      const enableCfhFields = function (): void {
        const disableFields = !cfhCb.checked
        cfhFields.forEach((el) => {
          if (el instanceof HTMLInputElement || el instanceof HTMLButtonElement) {
            el.disabled = disableFields
          }
        })
      }

      cfhCb.addEventListener('change', function () {
        enableCfhFields()
      })
      enableCfhFields()
    }

    // handle dth documents field
    const dthDocumentsEl = activityFormEl.querySelector('div[data-is="event-dth-documents-field"]')
    if (dthDocumentsEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const EventDthDocumentsControl = await import('./vue-components/event-dth-documents-field.vue')

        window.activityDthDocumentsControl = tsInitVue(EventDthDocumentsControl.default, dthDocumentsEl, {
          uploadUrl: dthDocumentsEl.dataset.uploadUrl,
          categoryAutocompleteUrl: dthDocumentsEl.dataset.categoryAutocompleteUrl
        })
      })()
    }
  }


  if (document.querySelector('body.ospe-application.ospe-activity-participants')) {
    // participant's list can include multiple lists (PrePayment, FinalPayment)
    (async (): Promise<void> => {
      const grid = await import('./vue-components/ospe/ospe-participant-grid.vue')

      const participantsGridEl = document.querySelector('div[data-is="OspeParticipantGrid"][ref="participants-list"]')
      if (participantsGridEl) {
        window.ospeParticipantsGrid = tsInitVueGrid(grid.default, participantsGridEl)
      }
    })()
  } else {
    const candidatesListEl = document.querySelector('div[data-is="OspeParticipantGrid"][ref="candidates-list"]')
    if (candidatesListEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        const grid = await import('./vue-components/ospe/ospe-participant-grid.vue')
        window.ospeCandidatesGrid = tsInitVueGrid(grid.default, candidatesListEl)
      })()
    }

    const projectsListEl = document.querySelector('div[data-is="OspeProjectGrid"][ref="projects-list"]')
    if (projectsListEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        const grid = await import('./vue-components/ospe/ospe-project-grid.vue')
        window.ospeProjectsGrid = tsInitVueGrid(grid.default, projectsListEl)
      })()
    }
  }

  // FIXME: check if this is obsolete?
  const participantsList = document.querySelector('body.ospe-application.ospe-activities')
  if (participantsList) {
    (async (): Promise<void> => {
      const grid = await import('./vue-components/ospe/ospe-participant-grid.vue')

      const reloadGrids = function (): void {
        if (window.ospeParticipantsGrid) {
          (window.ospeParticipantsGrid as any).reload()
        }
        if (window.ospeSelectedCandidatesGrid) {
          (window.ospeSelectedCandidatesGrid as any).reload()
        }
      }

      const participantsGridEl = document.querySelector('div[data-is="ospe-participant-grid"][ref="participants"]')
      if (participantsGridEl) {
        window.ospeParticipantsGrid = tsInitVueGrid(grid.default, participantsGridEl, {
          onDataChanged: function() {
            reloadGrids()
          }
        })
      }

      const selectedCandidatesGridEl = document.querySelector('div[data-is="ospe-participant-grid"][ref="selectedCandidates"]')
      if (selectedCandidatesGridEl) {
        window.ospeSelectedCandidatesGrid = tsInitVueGrid(grid.default, selectedCandidatesGridEl, {
          onDataChanged: function() {
            reloadGrids()
          }
        })
      }
    })()
  }

  if (document.querySelector('body.ospe-activity-email-templates')) {
    document.querySelectorAll<HTMLElement>('[data-bs-toggle="popover"]').forEach((el) => Popover.getOrCreateInstance(el, { trigger: 'hover' }))

    const templateAttachmentsEl = document.querySelector('div[data-is="EventEmailTemplateAttachments"]')
    if (templateAttachmentsEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        const emailAttachmentsComponent = await import("./vue-components/event-email-template-attachments.vue")
        const templateAttachmentsProps = {
          fieldName: templateAttachmentsEl.dataset.fieldName || '',
          initialFiles: (window as any).templateAttachmentFiles,
          uploadUrl: templateAttachmentsEl.dataset.uploadUrl,
        }
        window.ospeActivityTemplateAttachments = tsInitVue(emailAttachmentsComponent.default, templateAttachmentsEl, templateAttachmentsProps)
      })()
    }

    const templateTestEl = document.querySelector('div[data-is="EventEmailTemplateTest"]')
    if (templateTestEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const EmailTestComponent = await import("./vue-components/event-email-template-test.vue")
        window.ospeEmailTemplateTest = tsInitVue(EmailTestComponent.default, templateTestEl, {
          defaultRecipient: templateTestEl.dataset.defaultRecipient,
          sendUrl: templateTestEl.dataset.sendUrl,
          emailTemplates: (window as any).emailTemplates
        })
      })()
    }

    const copyDefaultTemplate = function(actionName: string, copyUrl: string): void {
      let warningMessage = ''
      if (actionName === 'copy-subject-and-body') {
        warningMessage = 'Warning! This will replace subject and body of your custom message with default message. Are you sure?'
      } else if (actionName === 'copy-subject') {
        warningMessage = 'Warning! This will replace subject of your custom message with default message. Are you sure?'
      } else if (actionName === 'copy-body') {
        warningMessage = 'Warning! This will replace body of your custom message with default message. Are you sure?'
      } else {
        return
      }

      if (confirm(warningMessage)) {
        axios.post(copyUrl, {}, {
          headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'X-Requested-With': 'XMLHttpRequest',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'X-CSRF-Token': Rails.csrfToken()
          }
        })
          .then((response) => {
            if (actionName === 'copy-subject-and-body') {
              $('input[name="ospe_activity_email_template[subject]"]').val(response.data.subject)
              window.fWYSIWYG.get('ospe_activity_email_template_body_html').setContent(response.data.body)
            } else if (actionName === 'copy-subject') {
              $('input[name="ospe_activity_email_template[subject]"]').val(response.data.subject)
            } else if (actionName === 'copy-body') {
              window.fWYSIWYG.get('ospe_activity_email_template_body_html').setContent(response.data.body)
            }
          })
          .catch((error) => {
            alert(`An error occured: ${error.message}`)
          })

      }
    }

    $('[ref="restore-generic-message"] .dropdown-item[data-action]').click(function (e) {
      e.preventDefault()
      const actionName = $(this).data('action')
      const copyUrl = $(this).closest('[ref="restore-generic-message"]').data('url')
      copyDefaultTemplate(actionName, copyUrl)
    })
  }

  if (document.querySelector('body.ospe-application.ospe-activity-participant-registration-details')) {
    const refundTypeRowEl = document.querySelector('div[ref="refund-type-row"]') as HTMLElement | null
    const participantStatusEl = document.querySelector('select[ref="status-id"]') as HTMLSelectElement | null
    const transportRefundEl = document.querySelector('select[ref="transport-refund-type"]') as HTMLSelectElement | null
    const perDiemRefundEl = document.querySelector('select[ref="per-diem-refund-type"]') as HTMLSelectElement | null
    // const perDiemRefundLabelEl = document.querySelector(perDiemRefundEl).siblings('label')
    const participantBankDetailsEl = document.querySelector('fieldset[ref="participant-bank-details"]') as HTMLElement | null
    const institutionBankDetailsEl = document.querySelector('fieldset[ref="institution-bank-details"]') as HTMLElement | null
    const refundInfoRows = document.querySelectorAll('div[ref="refund-info-row"]')

    const participantBankType = parseInt(participantBankDetailsEl?.dataset.refundType || '-1')
    const institutionBankType = parseInt(institutionBankDetailsEl?.dataset.refundType || '-1')

    const enableBankDetails = function(): void {
      let bankDetailsHidden = false
      if (participantStatusEl) {
        const statusId = parseInt(participantStatusEl.value)
        if (statusId === 3) {
          bankDetailsHidden = true

          // hide all bank details fields
          refundTypeRowEl?.classList.add('d-none')
          participantBankDetailsEl?.classList.add('d-none')
          institutionBankDetailsEl?.classList.add('d-none')
          participantBankDetailsEl?.setAttribute('disabled', '')
          institutionBankDetailsEl?.setAttribute('disabled', '')

          refundInfoRows.forEach((el) => {
            if (el instanceof HTMLElement) {
              el.classList.add('d-none')
            }
          })
        } else {
          refundTypeRowEl?.classList.remove('d-none')
        }
      }

      if (bankDetailsHidden) {
        return
      }

      if (transportRefundEl && perDiemRefundEl) {
        const v1 = parseInt(transportRefundEl.value)
        const v2 = parseInt(perDiemRefundEl.value)

        if (v1 === participantBankType || v2 === participantBankType) {
          participantBankDetailsEl?.classList.remove('d-none')
          if (refundInfoRows.length > 0) {
            refundInfoRows[0].classList.remove('d-none')
          }
          participantBankDetailsEl?.removeAttribute('disabled')
        } else {
          participantBankDetailsEl?.classList.add('d-none')
          if (refundInfoRows.length > 0) {
            refundInfoRows[0].classList.add('d-none')
          }
          participantBankDetailsEl?.setAttribute('disabled', '')
        }

        if (v1 === institutionBankType || v2 === institutionBankType) {
          institutionBankDetailsEl?.classList.remove('d-none')
          if (refundInfoRows.length > 1) {
            refundInfoRows[1].classList.remove('d-none')
          }
          institutionBankDetailsEl?.removeAttribute('disabled')
        } else {
          institutionBankDetailsEl?.classList.add('d-none')
          if (refundInfoRows.length > 1) {
            refundInfoRows[1].classList.add('d-none')
          }
          institutionBankDetailsEl?.setAttribute('disabled', '')
        }
      }
    }

    if (participantStatusEl) {
      participantStatusEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    if (transportRefundEl) {
      transportRefundEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    if (perDiemRefundEl) {
      perDiemRefundEl.addEventListener('change', function () {
        enableBankDetails()
      })
    }

    const activitiesEl = document.querySelector('div[data-is="CurricularActivityRegistration"]')
    if (activitiesEl instanceof HTMLElement) {
      const valueFieldRef = activitiesEl.dataset.valueFieldRef
      window.registrationActivities = tsInitVue(CurricularActivityRegistration, activitiesEl, {
        valueFieldRef
      })
    }


    // set initial state for bank details
    enableBankDetails()
  }

  // AIAKOS participant import
  if (document.querySelector('body.ospe-application.ospe-data-import-batches')) {
    const gridEl = document.querySelector('div[data-is="grid"]')
    if (gridEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        const grid = await import('./vue-components/ospe/ospe-data-import-grid.vue')
        window.importBatchItemsGrid = tsInitVueGrid(grid.default, gridEl)
      })()
    }
  }

  // Report submissions
  if (document.querySelector('body.ospe-application.ospe-activity-report-files')) {
    const gridEl = document.querySelector('div[data-is="OspeActivityReportSubmissionsGrid"]')
    if (gridEl instanceof HTMLElement) {
      (async (): Promise<void> => {
        const grid = await import('./vue-components/ospe/ospe-activity-report-submissions-grid.vue')
        window.reportSubmissionsGrid = tsInitVueGrid(grid.default, gridEl)
      })()
    }
  }

  //
  // Favorites handling
  //
  const editFavoritesEl = document.querySelector('.x-sidebar .activity-favorites .edit-favorites')
  if (editFavoritesEl instanceof HTMLElement) {
    editFavoritesEl.addEventListener('click', function (e) {
      e.preventDefault()
      const favoritesUrl = editFavoritesEl.dataset.url
      if (isNonEmptyString(favoritesUrl)) {
        if (window.favoritesModal == null) {
          (async (): Promise<void> => {
            const favoriteItemsModal = await import('../js/vue-components/favorite-items-modal.vue')

            const favoritesModalEl = document.createElement('div')
            const portalWrapEl = document.getElementById('vue-portal-wrap')
            if (portalWrapEl instanceof HTMLElement) {
              portalWrapEl.append(favoritesModalEl)
              window.favoritesModal = tsInitVue(favoriteItemsModal.default, favoritesModalEl, {
                dataUrl: favoritesUrl,
                modalTitle: 'Manage favorite activities',
                loadingMessage: 'Loading activities',
                searchPlaceholder: 'Search for activity',
                menuElementId: 'favoriteActivitiesMenu'
              })
            }

            window.favoritesModal.showModal()
          })()
        } else {
          window.favoritesModal.showModal()
        }
      }
    })
  }

  const expertsGridEl = document.querySelector('div[data-is="OspeActivityExpertsGrid"]')
  if (expertsGridEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const grid = await import('./vue-components/ospe/ospe-activity-experts-grid.vue')
      window.activityExpertsGrid = tsInitVueGrid(grid.default, expertsGridEl)
    })()
  }

  const activityPlacesGridEl = document.querySelector('div[data-is="ActivityPlacesGrid"]')
  if (activityPlacesGridEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const grid = await import('./vue-components/ospe/activity-places-grid.vue')
      window.activityPlacesGrid = tsInitVueGrid(grid.default, activityPlacesGridEl)
    })()
  }
})
